<template>
    <div class="col-12 col-lg-6 col-xl-4 pb-1 pb-lg-3 no-inner-padding">
        <div class="card">
            <a :href="newsItem.url">
                <div class="card__background position-relative mb-1">
                    <lazy-background
                        v-if="newsItem.imageObject !== null"
                        :image="newsItem.imageObject"
                    ></lazy-background>
                    <div class="card__content text-right">
                        <span>{{ newsItem.publishDate }}</span>
                    </div>
                </div>
                <h3 class="uppercase">
                    {{ newsItem.title }}
                </h3>
            </a>
        </div>
    </div>
</template>

<script>
import LazyBackground from '@/components/lazy-background';

export default {
    components: {
        LazyBackground
    },
    props: {
        newsItem: {
            type: Object,
            default() {
                return {};
            }
        }
    }
};
</script>
